export default __webpack_public_path__ + "static/media/paint-brush-icon.d53e3520.svg";